import { MRT_RowData, MRT_TableOptions } from 'mantine-react-table';
import { NotificationItem } from './types';

export function getBaseTableConfig<T extends MRT_RowData = NotificationItem>(): Partial<MRT_TableOptions<T>> {
  return {
    enableRowSelection: true,
    enableSelectAll: true,
    enableFilters: false,
    enableColumnFilters: false,
    enablePagination: true,
    enableColumnActions: false,
    enableTopToolbar: true,
    enableBottomToolbar: true,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableHiding: false,
    enableRowActions: true,
    enableToolbarInternalActions: false,
    positionGlobalFilter: 'left' as const,
    positionActionsColumn: 'last' as const,
    enableSorting: false,
    initialState: {
      density: 'xs' as const,
      pagination: { pageIndex: 0, pageSize: 20 },
    },
    displayColumnDefOptions: {
      'mrt-row-select': {
        size: 10,
      },
    },
    mantineTableProps: {
      highlightOnHover: true,
    },
    mantinePaperProps: {
      shadow: 'sm',
      withBorder: true,
      style: { height: '100%', display: 'flex', flexDirection: 'column' },
    },
    mantineTableContainerProps: {
      style: {
        flex: 1,
        overflow: 'auto',
      },
    },
    mantineTableHeadCellProps: {
      style: {
        fontWeight: '500',
      },
    },
  };
}
